import BaseInitFlowAction from "@/action/actions/BaseInitFlowAction"
import ActionId from "@/action/ActionId"
import {applicationState, providerState, sessionState} from "@/state"
import router from "@/router"
import SwitchProviderAction from "@/action/actions/SwitchProviderAction"

class InitApplyFlowAction extends BaseInitFlowAction {

    constructor(route, response) {
        super(ActionId.INIT_APPLY, route, response)
    }

    async initData() {
        await super.initData()
        const response = this.response
        sessionState.environment = response.environment
        applicationState.application = response.application || {}
        applicationState.resume = response.resume

        if (response.providerStates) {
            response.providerStates.forEach(providerResponseState => setProviderResponseState(providerResponseState))
        }

        //TODO: remove after cascading is done and we know the primary provider
        if (response.start.providers && response.start.providers.length) {
            providerState.primaryProvider = response.start.providers[0]
            applicationState.primaryLenderApplyMode = response.start.applyMode
        }
    }

    async next() {
        const response = this.response

        await SwitchProviderAction.handleResponse(response.start)

        if (response.resume) {
            return router.replace({ path: `/providers/${response.start.providerKey}/resume` })
        }

        return super.next()
    }
}


function setProviderResponseState(responseState) {
    if (responseState.paymentPlans) {
        providerState.setPaymentPlans(responseState.providerKey, responseState.paymentPlans)
    }

    if (responseState.preauthResponse) {
        providerState.setPreAuthResponse(responseState.providerKey, responseState.preauthResponse)
    }

    if (responseState.applyResponse) {
        providerState.setApplyResponse(responseState.providerKey, responseState.applyResponse)
    }
}

export default InitApplyFlowAction
